<template>
  <div style="height: 100%">
    <!--    公务出差支付-->
    <div class="receptionPay">
      <div class="tytitle">
        缴费情况
      </div>
      <div class="receptionPay_search">
        <van-search v-model="queryInfo.fuzzyField" placeholder="搜索通知书号、缴款人、手机号" @search="onSearch"/>
      </div>
      <div class="receptionPay_tab">
        <div v-for="(item,index) in tabList" :class="[active == index ? 'tabActive':'']" @click="switchTab(index,item)">
          <p>{{ item.title }}</p>
        </div>
      </div>
      <div class="receptionPay_body">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="height: 98%;overflow-y: auto">
          <div class="receptionPay_body_list">
            <div v-for="(item,index) in listData" :key="index" @click="routerJump(item)">
              <img src="../../assets/img/receptionUnit/unit.png" alt="">
              <div>
                <div>
                  <h2>{{ item.paymentUnit }}</h2>
                  <h2>{{ item.paymentTotal }}</h2>
                </div>
                <div>
                  <h2>{{ item.travelPaymentType }}</h2>
                  <h3>{{ item.isBill }}</h3>
                </div>
                <div>
                  <h2>
                    {{ item.createTime }}
                  </h2>
                </div>
              </div>
            </div>

          </div>
          <div class="replay">
            <div v-if="listData.length < total" @click="handlePage">
              <van-icon name="replay"/>
              点击加载更多数据
            </div>
            <div v-else>暂无更多数据</div>
          </div>
        </van-pull-refresh>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "pay",
  data() {
    return {

      total: 2,
      queryInfo: {
        fuzzyField: '',
        deptIds: [],
        travelPaymentType: '',
        page: 1,
        limit: 10
      },
      active: 0,
      tabList: [
        {
          title: "全部",
          value: ''
        },
        {
          title: "伙食费",
          value: 'meal'
        },
        {
          title: "交通费",
          value: 'transport'
        }
      ],
      listData: [],
      isLoading: false,
      vde: '',
      activeValue:''
    }
  },
  mounted() {
    this.vde = this.$route.query.vde
    this.queryInfo.deptIds = [this.vde]
    this.getDataList(this.queryInfo)
  },
  methods: {
    onSearch(val) {
      this.queryInfo.fuzzyField = val
      this.listData = []
      this.getDataList(this.queryInfo)
    },
    switchTab(index, item) {
      this.active = index
      this.activeValue = item.value
      this.queryInfo.travelPaymentType = item.value
      this.listData = []
      this.getDataList(this.queryInfo)
    },
    onRefresh() {
      this.isLoading = false
      this.listData = []
      this.queryInfo = {
        deptIds: [this.vde],
        travelPaymentType: this.activeValue,
        page: 1,
        limit: 10
      }
      this.getDataList(this.queryInfo)
    },
    handlePage() {
      this.queryInfo.page++;
      this.getDataList(this.queryInfo);
    },
    getDataList(queryInfo) {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      })
      this.isLoading = true
      this.request({
        url: '/travel/h5/listH5TravelDetail',
        method: 'post',
        data: queryInfo
      }).then(res => {
        this.$toast.clear()
        let data = res.data
        if (data.code == 1000) {
          this.total = data.result.total
          if (data.result.list && data.result.list.length) {
            this.listData.push(...data.result.list || [])
          }
        }
        this.isLoading = false
      })
    },
    routerJump(item) {
      this.$router.push({
        path: '/receptionUnit/orderDetails',
        query: {
          vde: this.vde,
          payBusinessUid: item.travelId
        }
      })
    },

  }
}
</script>

<style lang="scss" scoped>
.tytitle {
  height: 44px;
  line-height: 44px;
  font-size: 17px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
  background: #fff;
  border-bottom: 0.5px solid #ebedf0;
}

.receptionPay {
  height: 100%;

  .replay {
    text-align: center;
    color: #7e7e7e;
    margin: 20px;
  }

  ::v-deep .van-pull-refresh__head {
    color: #464a4c !important;
  }
}

.receptionPay_search {
  height: 44px;
  //padding: 0 29px;
  line-height: 44px;

  ::v-deep .van-search__content {
    background: transparent !important;
  }
}

.receptionPay_tab {
  height: 44px;
  line-height: 44px;
  display: flex;
  justify-content: start;
  padding-left: 30px;
  background: #fff;
  border-top: 0.5px solid #ebedf0;


  //&::after {
  //  position: absolute;
  //  box-sizing: border-box;
  //  content: ' ';
  //  pointer-events: none;
  //  top: -50%;
  //  right: -50%;
  //  bottom: -50%;
  //  left: -50%;
  //  border: 0 solid #ebedf0;
  //  transform: scale(.5);
  //}
  > div {
    margin-right: 20px;

    > p {

      font-size: 16px;
      color: #858585;
      letter-spacing: 0;
      font-weight: 400;
    }
  }

  .tabActive {
    position: relative;

    p {
      color: #208fff !important;
    }

    &:before {
      position: absolute;
      content: "";
      height: 0.05333rem;
      width: 100%;
      background: #208fff;
      bottom: 0;

    }
  }
}

.receptionPay_body {
  height: calc(100% - 132px);
  overflow-y: auto;
  padding-left: 15px;


  .receptionPay_body_list {
    margin-top: 10px;
    border-radius: 10px;
    overflow: hidden;

    > div {
      height: 90px;
      background: #FFFFFF;
      box-shadow: 0px -1px 0px 0px rgba(238, 238, 238, 0.5);
      display: flex;
      padding: 0 20px;
      margin-right: 15px;

      img {
        height: 37px;
        width: 37px;
        margin: 20px 12px 0 0;
      }

      h2, h3 {
        margin: 0;
      }

      > div {
        flex: 1 1 auto;

        > div:nth-of-type(1) {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;

          h2:nth-of-type(1) {

            font-size: 16px;
            color: #464A4C;
            letter-spacing: 0;
            font-weight: 400;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 190px
          }
          h2:nth-of-type(2){

            font-size: 16px;
            color: #464A4C;
            letter-spacing: 0;
            font-weight: 400;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100px
          }

        }

        > div:nth-of-type(2) {
          display: flex;
          justify-content: space-between;
          margin: 6px 0 4px 0;

          h2 {
            width: 60px;
            height: 17px;

            font-size: 12px;
            color: #999999;
            letter-spacing: 0;
            font-weight: 400;
          }

          h3 {
            width: 36px;
            height: 17px;

            font-size: 12px;
            color: #F46C6C;
            letter-spacing: 0;
            font-weight: 400;
          }
        }

        > div:nth-of-type(3) {
          h2 {

            font-size: 12px;
            color: #999999;
            letter-spacing: 0;
            font-weight: 400;
          }
        }
      }


    }
  }
}
</style>
